module.exports = __webpack_public_path__ + "static/media/40.67a56f4e.jpg";